// angular.module("HeroPRO")
// 	.directive('directoryBox',

/* @ngInject */
export default function DirectoryBoxDirective() {
    return {
        restrict: 'E',
        templateUrl: 'app/productCenter/pages/productdirectory/directoryBox/directoryBox.html',
        controller: 'DirectoryBoxController',
        controllerAs: 'product',
    };
}



// WEBPACK FOOTER //
// ./src/app/productCenter/pages/productdirectory/directoryBox/directoryBox.directive.js